import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  FormHelperText,
} from "@mui/material";
import { React, useState } from "react";
import FlexButton from "../../../components/FlexButton";
import { apiRouterCall } from "../../../api/services";
import SubscribeModal from "../../../components/modals/SubscribeModal";
import ScreenLoader from "../../../components/screenLoader";

export default function CryptoToday({ themeSettings }) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [emailData, setEmailData] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const subscribeHandler = async () => {
    try {
      setIsProcessing(true);
      const response = await apiRouterCall({
        method: "POST",
        endPoint: "subscribe",
        data: {
          email: emailData,
        },
      });
      if (response?.data?.responseCode === 200) {
        setOpenModal(true);
        setEmailData("");
      }
      setIsProcessing(false);
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
    }
  };

  return (
    <Box className="mainContainer" sx={{ margin: "80px 0px" }}>
      <Container>
        <Box sx={{ marginTop: "50px", padding: "30px 10px" }}>
          <Grid container p={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="h4">
                Stay updated on all things about crypto all the time
              </Typography>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
              <Typography variant="h6">
                Get the regular emails with the latest crypto market trends,
                insights, latest crypto news, events, and much more.
              </Typography>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
              <Grid container spacing={1}>
                <Grid item lg={9} md={9} sm={9} xs={12}>
                  <TextField
                    fullWidth
                    placeholder="Enter your email address...."
                    sx={{ marginRight: "20px" }}
                    value={emailData}
                    onChange={(e) => {
                      const regx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
                      const check = regx.test(e.target.value);

                      setIsValid(check);
                      setEmailData(e.target.value);
                    }}
                    error={
                      (isSubmit && emailData === "") ||
                      (!isValid && emailData !== "")
                    }
                    helperText={
                      isSubmit &&
                      emailData === "" &&
                      "Please enter your email to join us"
                    }
                  />
                  {!isValid && emailData !== "" && (
                    <FormHelperText error>
                      Please enter a valid email.
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item lg={2} md={3} xs={12} sm={3}>
                  <FlexButton
                    fullWidth
                    color="primary"
                    title="Subscribe"
                    onClick={() => {
                      setIsSubmit(true);
                      if (emailData !== "") {
                        setIsSubmit(false);
                        subscribeHandler();
                      }
                    }}
                    disabled={!isValid}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
      {isProcessing && (
        <ScreenLoader
          open={isProcessing}
          close={() => setIsProcessing(false)}
        />
      )}
      {openModal && (
        <SubscribeModal open={openModal} close={() => setOpenModal(false)} />
      )}
    </Box>
  );
}
